import { __assign, __awaiter, __generator } from "tslib";
import * as sessionReplay from '@amplitude/session-replay-browser';
import Cookie from 'js-cookie';
import { VERSION } from './version';
var getStoredSessionId = function () {
    var storedId = Cookie.get('amp_session_id');
    if (storedId) {
        return parseInt(storedId, 10);
    }
    return undefined;
};
var getUserId = function (ctx) {
    var userId = ctx.event.userId || ctx.event.anonymousId;
    return userId;
};
export var updateSessionIdAndAddProperties = function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var storedSessionId, amplitudeIntegrationData, nextSessionId, deviceId, sessionReplayProperties, properties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                storedSessionId = getStoredSessionId() || 0;
                amplitudeIntegrationData = ctx.event.integrations && ctx.event.integrations['Actions Amplitude'];
                nextSessionId = amplitudeIntegrationData === null || amplitudeIntegrationData === void 0 ? void 0 : amplitudeIntegrationData.session_id;
                if (!(nextSessionId && storedSessionId < nextSessionId)) return [3 /*break*/, 2];
                Cookie.set('amp_session_id', nextSessionId.toString());
                deviceId = getUserId(ctx);
                return [4 /*yield*/, sessionReplay.setSessionId(nextSessionId, deviceId).promise];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, sessionReplay.evaluateTargetingAndCapture({
                    event: {
                        event_type: ctx.event.event || '',
                        event_properties: ctx.event.properties,
                        time: ctx.event.timestamp instanceof Date ? ctx.event.timestamp.getTime() : undefined,
                    },
                    userProperties: ctx.event.traits,
                })];
            case 3:
                _a.sent();
                sessionReplayProperties = sessionReplay.getSessionReplayProperties();
                properties = __assign(__assign({}, ctx.event.properties), sessionReplayProperties);
                ctx.updateEvent('properties', properties);
                return [2 /*return*/, ctx];
        }
    });
}); };
export var createSegmentActionsPlugin = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var initPromise, sessionReplayPlugin;
    var amplitudeApiKey = _b.amplitudeApiKey, sessionReplayOptions = _b.sessionReplayOptions, segmentInstance = _b.segmentInstance;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                sessionReplayPlugin = {
                    name: 'Session Replay Events',
                    type: 'enrichment',
                    version: VERSION,
                    isLoaded: function () { return true; },
                    load: function (_ctx, ajs) { return __awaiter(void 0, void 0, void 0, function () {
                        var user, deviceId, storedSessionId;
                        return __generator(this, function (_a) {
                            user = ajs.user();
                            deviceId = user.anonymousId();
                            storedSessionId = getStoredSessionId();
                            initPromise = sessionReplay.init(amplitudeApiKey, __assign(__assign({}, sessionReplayOptions), { sessionId: storedSessionId, deviceId: deviceId || undefined, version: { type: 'segment', version: VERSION }, userProperties: user.traits() })).promise;
                            return [2 /*return*/];
                        });
                    }); },
                    track: function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, initPromise];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, updateSessionIdAndAddProperties(ctx)];
                                case 2: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); },
                    page: function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, initPromise];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, updateSessionIdAndAddProperties(ctx)];
                                case 2: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); },
                    identify: function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
                        var deviceId, sessionId, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, initPromise];
                                case 1:
                                    _b.sent();
                                    deviceId = getUserId(ctx);
                                    sessionId = sessionReplay.getSessionId();
                                    _a = sessionId;
                                    if (!_a) return [3 /*break*/, 3];
                                    return [4 /*yield*/, sessionReplay.setSessionId(sessionId, deviceId).promise];
                                case 2:
                                    _a = (_b.sent());
                                    _b.label = 3;
                                case 3:
                                    _a;
                                    return [4 /*yield*/, sessionReplay.evaluateTargetingAndCapture({ userProperties: ctx.event.traits })];
                                case 4:
                                    _b.sent();
                                    return [2 /*return*/, ctx];
                            }
                        });
                    }); },
                };
                return [4 /*yield*/, segmentInstance.register(sessionReplayPlugin)];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=actions.js.map